/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import axios, { AxiosResponse } from "axios";

import { ApplicationStatus } from "../../components/constants";
import { ReferenceStatusUpdate } from "./applications-api.types";
import axiosInstance from "./axiosConfig";
import { config } from "../config";
import { getTokenClaimsFromAccountDetails } from "../auth/msal";
import { getURLParams } from "../../components/util";

export const applicationApi = {
  //eslint-disable-next-line
  getBlobAccessToken: (): Promise<AxiosResponse<any>> => {
    return axiosInstance.get(config.api.getBlobAccessToken);
  },

  //eslint-disable-next-line
  declineRequest: (): Promise<AxiosResponse<any>> => {
    const params: ReferenceStatusUpdate = {
      candidateId: parseInt(getURLParams().candidateId),
      referenceId: parseInt(getURLParams().referenceId),
      status: ApplicationStatus.DECLINED,
    };
    return axiosInstance.patch(config.api.statusUpdate, params);
  },

  //eslint-disable-next-line
  getReFerenceMetadata: (): Promise<AxiosResponse<any>> => {
    const url = `${config.api.getReferenceMetaData}?candidateId=${parseInt(
      getURLParams().candidateId
    )}&referenceId=${parseInt(getURLParams().referenceId)}`;
    return axiosInstance.get(url);
  },

  //Reference History Data
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getReferenceHistory: (): Promise<AxiosResponse<any>> => {
    const historyParams = {
      candidateId: getURLParams().candidateId,
      referenceProviderEmail: getTokenClaimsFromAccountDetails().email,
    };
    const referenceHistoryEndPoint = config.api.referenceHistory
      .replace("{candidateId}", historyParams.candidateId)
      .replace(
        "{referenceProviderEmail}",
        historyParams.referenceProviderEmail
      );
    return axiosInstance.get(referenceHistoryEndPoint);
  },

  //Reference History File
  getReferenceHistoryFile: (
    referenceId: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<AxiosResponse<any>> => {
    const historyParams = {
      candidateId: getURLParams().candidateId,
      referenceId: referenceId,
    };
    const referenceHistoryBlobEndPoint = config.api.referenceHistoryBlob
      .replace("{candidateId}", historyParams.candidateId)
      .replace("{referenceId}", historyParams.referenceId.toString());
    return axiosInstance.get(referenceHistoryBlobEndPoint);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPlannedDowntime: (): Promise<AxiosResponse<any>> => {
    const plannedDownTimeEndpoint =
      config.monitoringEndPointURL + "&category=planned";

    return axios.get(plannedDownTimeEndpoint);
  },
};
